// Module
var code = "<react-component name=\"MembershipCancellationForm\"></react-component>\n";
// Exports
module.exports = code;